import { render, staticRenderFns } from "./EnvPartiStat.vue?vue&type=template&id=484a4e16&scoped=true"
import script from "./EnvPartiStat.vue?vue&type=script&lang=js"
export * from "./EnvPartiStat.vue?vue&type=script&lang=js"
import style0 from "./EnvPartiStat.vue?vue&type=style&index=0&id=484a4e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a4e16",
  null
  
)

export default component.exports